import controller from './categories-menu.controller';
import templateBase from './templates/categories-menu-base.view.html';
import templateT1 from './templates/categories-menu-t1.html';
import templateT2 from './templates/categories-menu-t2.html';
let CategoriesMenuComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        items: '<',
        hCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  try{
    let response = SessionService.get('components');
    if(response.HEADER_MENU.component == 'template_t1') {
      return templateT1;
    } else if(response.HEADER_MENU.component == 'template_t2') {
      return templateT2;
    }
    else {
      return templateBase;
    }
  }catch (e) {
    return templateT1;
  }



}

export default CategoriesMenuComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/categories-menu/categories-menu.component.js
 **/